/**
 * sounds.js — Audio management
 * All Audio objects, volume config, mute state, mobile unlock.
 */

// ── Audio objects ──────────────────────────────────────────────
export const sounds = {
    click:   new Audio('./audio/click.mp3'),
    shuffle: new Audio('./audio/shuffle.mp3'),
    loading: new Audio('./audio/loading.mp3'),
    final:   new Audio('./audio/final.mp3'),
    final2:  new Audio('./audio/final2.mp3'),
    coin:    new Audio('./audio/coin.mp3'),
    woosh:   new Audio('./audio/woosh1.wav'),
}

sounds.click.volume   = 1
sounds.loading.volume = 0.4
sounds.final.volume   = 1
sounds.final2.volume  = 0.5
sounds.woosh.volume   = 0.5

// ── Mute state ─────────────────────────────────────────────────
let _muted = false

export function isMuted()       { return _muted }
export function setMuted(val)   { _muted = Boolean(val) }

// ── play helper ────────────────────────────────────────────────
// Usage: play('click')  play('final')  etc.
// Silently fails if muted or sound name doesn't exist.
export function play(name) {
    if (_muted) return
    const s = sounds[name]
    if (!s) return
    s.currentTime = 0
    s.play().catch(() => {})
}

// ── Mobile audio unlock ────────────────────────────────────────
// Browsers block audio until first user gesture.
// This fires once on first click and unlocks the audio context.
function unlockAudio() {
    const silent = new SpeechSynthesisUtterance('')
    window.speechSynthesis.speak(silent)
    window.removeEventListener('click', unlockAudio)
}

window.addEventListener('click', unlockAudio)
